import { useTheme } from "@mui/material";
import React from "react";

export const ErrorLabel = ({ text }: { text: string }) => {
	const theme = useTheme();

	return (
		<span
			style={{
				fontSize: 12,
				color: theme.palette.error.main,
			}}
		>
			{text}
		</span>
	);
};
